import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
// Create context with default values
const ToastContext = React.createContext({
    toasts: [],
    toast: () => "",
    dismiss: () => { },
    dismissAll: () => { },
});
export function ToastProvider({ children }) {
    const [toasts, setToasts] = React.useState([]);
    // Add toast
    const toast = React.useCallback((props) => {
        const id = Math.random().toString(36).substring(2, 9);
        setToasts((prevToasts) => [...prevToasts, { ...props, id }]);
        // Auto dismiss after specified duration or default 5 seconds
        const duration = props.duration || 5000;
        setTimeout(() => {
            dismiss(id);
        }, duration);
        return id;
    }, []);
    // Remove specific toast
    const dismiss = React.useCallback((id) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }, []);
    // Remove all toasts
    const dismissAll = React.useCallback(() => {
        setToasts([]);
    }, []);
    return (_jsxs(ToastContext.Provider, { value: { toasts, toast, dismiss, dismissAll }, children: [children, _jsx(ToastContainer, {})] }));
}
// Toast container component
function ToastContainer() {
    const { toasts, dismiss } = React.useContext(ToastContext);
    if (toasts.length === 0)
        return null;
    return (_jsx("div", { className: "fixed top-0 right-0 z-50 p-4 flex flex-col gap-2 max-w-[420px] max-h-screen overflow-hidden", children: toasts.map((toast) => (_jsxs("div", { className: `bg-card border rounded-md shadow-lg p-4 transition-all duration-300 ease-in-out relative ${toast.variant === "destructive" ? "border-red-500" : "border-gray-200 dark:border-border"}`, children: [_jsx("button", { onClick: () => dismiss(toast.id), className: "absolute top-2 right-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200", children: "\u2715" }), toast.title && (_jsx("div", { className: "font-semibold mb-1", children: toast.title })), toast.description && _jsx("div", { children: toast.description })] }, toast.id))) }));
}
// Custom hook to use toast
export function useToast() {
    const context = React.useContext(ToastContext);
    if (context === undefined) {
        throw new Error("useToast must be used within a ToastProvider");
    }
    return context;
}
// Export the Toaster component for layout usage
export function Toaster() {
    return null; // The ToastContainer is already rendered by the provider
}
